import { FlightSubLOBProps } from "components/flexComponents/WizardFlightPWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
import { FlightsFareCalendar } from "./FlightsFareCalendar";
import {
  UitkLayoutGrid,
  UitkLayoutConditionalGridSpan,
  UitkLayoutConditionalGridColumnRow,
} from "uitk-react-layout-grid";
import { LobErrorSummary } from "src/components/shared/LobErrorSummary/LobErrorSummary";
import { SubmitButton } from "src/components/shared/SubmitButton/SubmitButton";
import { getShoppingGlobalMicroMessage } from "src/components/shared/StorefrontWizard/SubmitRow/UISShoppingGlobal";

export const StickyRoundtripFlight = observer((props: FlightSubLOBProps) => {
  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 4, medium: 6, large: 12 };
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 6, large: 6 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 4, large: 4 };
  const submitColSpan: UitkLayoutConditionalGridSpan = { small: 4, medium: 2, large: 2 };
  const fareCalendarTest = "PWA_fare_calendar_home_page";
  const {
    errorInputRef,
    isRoundtripFormValid,
    numberOfErrors,
    updateInvalidFormsState,
    moreThanOneError,
  } = props.lobState;
  if (isRoundtripFormValid) {
    updateInvalidFormsState();
  }
  const uisShoppingGlobal = getShoppingGlobalMicroMessage(props.lobState);

  return (
    <UitkLayoutGrid columns={mainGridColumns} space="three" className="all-t-margin-two">
      {!isRoundtripFormValid && (
        <LobErrorSummary
          locHeadingToken={props.getLocError(false)!}
          locHeadingArgs={moreThanOneError() && [numberOfErrors]}
          locLinkToken={props.getLocError(true)}
          linkClickFocusId="id-roundtrip-error"
          inputErrorRef={errorInputRef}
          colSpan={mainGridColumns}
          setInputsRefs={props.setInputsRefs}
        />
      )}
      <Location
        setInputsRefs={props.setInputsRefs}
        originField={true}
        destinationField={true}
        lobState={props.lobState}
        showSwapLocationsControl={true}
        colSpan={locationColSpan}
      />
      <Experiment name={fareCalendarTest}>
        <ExperimentControl>
          <Dates
            lobState={props.lobState}
            colSpan={datesColSpan}
            singleDateSelect={true}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <FlightsFareCalendar
            singleDate={false}
            lobState={props.lobState}
            colSpan={datesColSpan}
            singleDateSelect={true}
            setInputsRefs={props.setInputsRefs}
          />
        </ExperimentVariant>
      </Experiment>
      <SubmitButton
        lobState={props.lobState}
        colSpan={submitColSpan}
        rfrr={props.flightConfig.referrerId}
        uisPrimeMicroMessages={uisShoppingGlobal}
      />
    </UitkLayoutGrid>
  );
});
